export const GET_DASHBOARD_DATA = "GET_DASHBOARD_DATA";
export const GET_DASHBOARD_DATA_SUCCESS = "GET_DASHBOARD_DATA_SUCCESS";
export const GET_DASHBOARD_DATA_FAILED = "GET_DASHBOARD_DATA_FAILED";
export const GET_TRANSACTION_DATA = "GET_TRANSACTION_DATA";
export const GET_TRANSACTION_DATA_SUCCESS = "GET_TRANSACTION_DATA_SUCCESS";
export const GET_TRANSACTION_DATA_FAILED = "GET_TRANSACTION_DATA_FAILED";
export const GET_AUM_DATA = "GET_AUM_DATA";
export const GET_AUM_DATA_SUCCESS = "GET_AUM_DATA_SUCCESS";
export const GET_AUM_DATA_FAILED = "GET_AUM_DATA_FAILED";
export const GET_FREQUENT_MAIL_BACK_REQUEST = "GET_FREQUENT_MAIL_BACK_REQUEST";
export const GET_FREQUENT_MAIL_BACK_REQUEST_SUCCESS =
  "GET_FREQUENT_MAIL_BACK_REQUEST_SUCCESS";
export const GET_FREQUENT_MAIL_BACK_REQUEST_FAILED =
  "GET_FREQUENT_MAIL_BACK_REQUEST_SUCCESS";

export const GET_DASHBOARD_AUM_DATA = "GET_DASHBOARD_AUM_DATA";
export const GET_DASHBOARD_AUM_DATA_SUCCESS = "GET_DASHBOARD_AUM_DATA_SUCCESS";
export const GET_DASHBOARD_AUM_DATA_FAILED = "GET_DASHBOARD_AUM_DATA_FAILED";

export const GET_SIP_SUMMARY_DATA = "GET_SIP_SUMMARY_DATA";
export const GET_SIP_SUMMARY_DATA_SUCCESS = "GET_SIP_SUMMARY_DATA_SUCCESS";
export const GET_SIP_SUMMARY_DATA_FAILED = "GET_SIP_SUMMARY_DATA_FAILED";

export const GET_NFO_SCHEMES = "GET_NFO_SCHEMES";
export const GET_NFO_SCHEMES_SUCCESS = "GET_NFO_SCHEMES_SUCCESS";
export const GET_NFO_SCHEMES_FAILED = "GET_NFO_SCHEMES_FAILED";

